export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/runner.33ff1cb1.worker.js");
}
